import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
  
    console.log("🟡 Ověřuji přihlašovací údaje...");
    if (email === "info@namasteindicka.cz" && password === "Namaste2025") {
      console.log("✅ Úspěšné přihlášení.");
      localStorage.setItem("admin_token", "valid");
  
      setTimeout(() => {
        navigate("/admin_change");
      }, 50); // malá prodleva, aby se token stihl zapsat
    } else {
      console.warn("❌ Neplatné přihlašovací údaje.");
      setError("Nesprávné přihlašovací údaje.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-orange-50 px-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md border border-orange-200">
        <h2 className="text-2xl font-bold text-center text-orange-700 mb-6">
          Přihlášení do administrace
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">E-mail</label>
            <input
              type="email"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Heslo</label>
            <input
              type="password"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-red-600 text-sm font-semibold">{error}</p>}
          <button
            type="submit"
            className="w-full bg-orange-600 text-white py-2 rounded hover:bg-red-600 transition"
          >
            Přihlásit se
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;